import { ofType } from 'redux-observable';
import { mergeMap, debounceTime } from 'rxjs/operators';
import { merge, of } from 'rxjs';

import { EXPORT_WATCH_LIST_ENTRIES_CSV } from '../types';
import { EXPORT_WATCH_LIST_ENTRIES_CSV_MESSAGES } from '../constants/exportWatchListEntriesCsvMessages';
import { exportWatchListEntriesCsvPending, exportWatchListEntriesCsvFulfilled, exportWatchListEntriesCsvRejected } from '../actions';
import { sendApiRequest, notifyError, notifyWarning } from '../../../actions';
import generateError from '../../../utilities/generateError';

const createPayload = payload => ({
  method: 'get',
  url: 'watchlist/GetWatchListEntriesExportCsv',
  onSuccess: [response => (response.data.length === 0
    ? notifyWarning(EXPORT_WATCH_LIST_ENTRIES_CSV_MESSAGES.NOT_FOUND)
    : exportWatchListEntriesCsvFulfilled(response))],
  onError: [
    exportWatchListEntriesCsvRejected,
    error => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: 'pdfApi',
};

const exportWatchListEntriesCsvEpic$ = (action$, state$) => action$.pipe(
  ofType(EXPORT_WATCH_LIST_ENTRIES_CSV.DEFAULT),
  debounceTime(500),
  mergeMap(({ payload }) => merge(
    of(exportWatchListEntriesCsvPending()),
    of(sendApiRequest(createPayload(payload), meta)),
  )),

);

export default exportWatchListEntriesCsvEpic$;


// WEBPACK FOOTER //
// ./src/features/watch-list-entry/epics/exportWatchListEntriesCsvEpic.js